import React from 'react';
import CartDetails from '../components/cart/CartDetails';
// import './CartPage.css';


const CartPage = () => {

    return (
        <CartDetails />
    );
};

export default CartPage;
// Removed duplicate export after refactor
